export const startSetupMission = (id) => ({
  type: "START_SETUP_MISSION",
  id
});



// WEBPACK FOOTER //
// ./src/store/actions/help/setup.js